import { Link, Outlet, useMatch } from 'react-router-dom';
import { Tabs, Typography, Wrapper } from '@screentone/core';

import { useConvertedProperty } from 'hooks';
import { ROLE_TYPE } from 'hooks/roles/types';
import useRequireRoles from 'hooks/roles/useRequireRoles';

const TAB_TITLES = {
  '': 'Content Presentation',
  'disable-content-presentation-parameters': 'Disable Content Presentation Parameters',
  'mobile-issues': 'Mobile Issue Management',
  'rules-config': 'Mobile Article Rules Configuration',
  pubcrawl: 'Pubcrawl Section ID Mapping',
  'disable-wsj-translation': 'Disable WSJ Translation',
  'itp-required-page-types': 'ITP Required Page Types',
} as const;

type TabValue = keyof typeof TAB_TITLES;

function SiteConfigMobileAndApp() {
  useRequireRoles(ROLE_TYPE.ADMIN);

  const currentProperty = useConvertedProperty();

  const tabMatch = useMatch('/:property/site-config/mobile-and-app/:tab');
  const tabParam = tabMatch?.params.tab ?? '';
  const activeTab: TabValue = tabParam in TAB_TITLES ? (tabParam as TabValue) : '';

  const basePath = `/${currentProperty ?? ''}/site-config/mobile-and-app`;
  const isWsj = currentProperty === 'wsj';

  return (
    <>
      <Typography variant="header2" margin={{ bottom: 'sm' }}>
        {TAB_TITLES[activeTab]}
      </Typography>
      <Tabs role="tablist" value={activeTab} margin={{ top: 'lg' }}>
        <Tabs.Item
          role="tab"
          id="tab-content-presentation"
          aria-controls="tabpanel-mobile"
          componentEl={Link}
          to={basePath}
          value=""
        >
          {TAB_TITLES['']}
        </Tabs.Item>
        {isWsj && (
          <Tabs.Item
            role="tab"
            id="tab-disable-content-presentation-parameters"
            aria-controls="tabpanel-mobile"
            componentEl={Link}
            to={`${basePath}/disable-content-presentation-parameters`}
            value="disable-content-presentation-parameters"
          >
            {TAB_TITLES['disable-content-presentation-parameters']}
          </Tabs.Item>
        )}
        <Tabs.Item
          role="tab"
          id="tab-mobile-issues"
          aria-controls="tabpanel-mobile"
          componentEl={Link}
          to={`${basePath}/mobile-issues`}
          value="mobile-issues"
        >
          {TAB_TITLES['mobile-issues']}
        </Tabs.Item>
        <Tabs.Item
          role="tab"
          id="tab-rules-config"
          aria-controls="tabpanel-mobile"
          componentEl={Link}
          to={`${basePath}/rules-config`}
          value="rules-config"
        >
          {TAB_TITLES['rules-config']}
        </Tabs.Item>
        <Tabs.Item
          role="tab"
          id="tab-pubcrawl"
          aria-controls="tabpanel-mobile"
          componentEl={Link}
          to={`${basePath}/pubcrawl`}
          value="pubcrawl"
        >
          {TAB_TITLES.pubcrawl}
        </Tabs.Item>
        {isWsj && (
          <Tabs.Item
            role="tab"
            id="tab-disable-wsj-translation"
            aria-controls="tabpanel-mobile"
            componentEl={Link}
            to={`${basePath}/disable-wsj-translation`}
            value="disable-wsj-translation"
          >
            {TAB_TITLES['disable-wsj-translation']}
          </Tabs.Item>
        )}
        {isWsj && (
          <Tabs.Item
            role="tab"
            id="tab-itp-required-page-types"
            aria-controls="tabpanel-mobile"
            componentEl={Link}
            to={`${basePath}/itp-required-page-types`}
            value="itp-required-page-types"
          >
            {TAB_TITLES['itp-required-page-types']}
          </Tabs.Item>
        )}
      </Tabs>
      <Wrapper id="tabpanel-mobile" role="tabpanel" padding={{ top: 'sm' }}>
        <Outlet />
      </Wrapper>
    </>
  );
}

export default SiteConfigMobileAndApp;
